import b2bFlowDiagram from './b2b-flow-diagram.json' with { type: 'json' };
import progressBar from './progress-bar.json' with { type: 'json' };
import sparkjsUpgradeAlert from './sparkjs-upgrade-alert.json' with { type: 'json' };

export default {
  b2b_flow_diagram: b2bFlowDiagram,
  progress_bar: progressBar,
  sparkjs_upgrade_alert: sparkjsUpgradeAlert,
};
